// @flow

export const toolsDashboardTodayKeys = {
  absentStaff: "absent_staff",
  absenceRate: "absence_rate",
  outstandingActions: "outstanding_actions",
  newAlerts: "new_alerts",
  newNotifications: "new_notifications",
};

export const toolsDashboardNotificationReviewsKeys = {
  new: "new",
  changed: "changed",
  removed: "removed",
  total: "total",
};

export const statItemPrefixMap = {
  PERCENTAGE: "%",
};
